import {
  fetchAppsAndOrgs,
  fetchCurrentOrg
} from '../../common/actions/OrgActions';
import { fetchCurrentApp } from '../../common/actions/AppActions';
import { loadRole, loadUser } from '../../common/actions/UserActions';
import {
  getDefaultRoles,
  getUserPermissions
} from '../actions/AccessControlActions';

import {
  AGENCY_VIEW,
  APP_VIEW,
  ORG_VIEW
} from '../../common/support/viewConstants';
import { getSSO } from '../actions/SsoActions';
import {
  getBookmarkedReports,
  mountFromLinkData,
  mountFromLocalStorage
} from '../../common/actions/ShareableActions';
import { hydrate } from '../actions/FlipperActions';
import {
  GetExportWhitelist,
  GetMau,
  GetMonthToDateMau,
  GetSubscriptions
} from '../actions/SubscriptionActions';
import { loadThirdPartyProviderConfig } from '../actions/ThirdPartyProviderConfigActions';
import { loadThirdPartyGlobalSettings } from '../actions/ThirdPartyGlobalSettingsActions';
import { getEmailProviderBlueprint } from '../actions/EmailOnboarding/EmailProviderBlueprint';
import { loadSDKInfo, loadSDKLatestInfo } from '../actions/SDKInfoActions';
import { getCustomDruidEvents } from '../../common/actions/DruidActions';
import * as QueryString from 'query-string';
import { getRangeInTimezoneEndingNow } from '../support/dateUtils';
import AnalyticsActions from '../actions/AnalyticsActions';
import * as RouterService from './RouterServices';

import debugLib from 'debug';
import { getUserAppTerms } from '../../common/actions/UserEntityTermsActions';

const debug = debugLib('MainApp');

export const initAccessControlWithAgencyUsers = (
  store: any,
  settings: { view: { current_view: string } }
) => {
  store.dispatch(loadUser()).then(state => {
    store.dispatch(
      getUserPermissions(
        state.agency_user,
        settings.view.current_view === AGENCY_VIEW
      )
    );
  });
  store.dispatch(getDefaultRoles());
  store.dispatch(loadRole());
};

const initBillingScreen = (store: any, current_view: string) => {
  // Fetch billing data for ORG_VIEW only when billing_redesign flipper is enabled
  if (current_view === APP_VIEW) {
    store.dispatch(GetSubscriptions.request());
    store.dispatch(GetMau.request());
    store.dispatch(GetMonthToDateMau.request());
    store.dispatch(GetExportWhitelist.request());
  } else if (
    RouterService.isActiveFlipper('billing_redesign') &&
    current_view === ORG_VIEW
  ) {
    store.dispatch(GetSubscriptions.request());
    store.dispatch(GetMau.request());
    store.dispatch(GetMonthToDateMau.request());
  }
};

export const ignite = (
  store: any,
  settings: { view: { current_view: string } }
) => {
  store.dispatch(fetchAppsAndOrgs());
  store.dispatch(fetchCurrentOrg());

  initAccessControlWithAgencyUsers(store, settings);

  store.dispatch(getSSO());

  store.dispatch(mountFromLocalStorage());
  store.dispatch(getBookmarkedReports());
  store.dispatch(hydrate());

  if (settings.view.current_view === APP_VIEW) {
    store.dispatch(fetchCurrentApp());
    store.dispatch(loadThirdPartyGlobalSettings());
    store.dispatch(loadThirdPartyProviderConfig());
    store.dispatch(getEmailProviderBlueprint());
    store.dispatch(loadSDKInfo());
    store.dispatch(loadSDKLatestInfo());
    store.dispatch(getCustomDruidEvents());
    store.dispatch(getUserAppTerms());
  }
  initBillingScreen(store, settings.view.current_view);
};

export const initDefaultAccessControl = store => {
  store.dispatch(loadRole());
  store.dispatch(loadUser());
  store.dispatch(getUserPermissions());
  store.dispatch(getDefaultRoles());
};

export const initAnalyticActions = () => {
  const query = QueryString.parse(location.search);
  if (query.date_range) {
    const date_range = getRangeInTimezoneEndingNow(parseInt(query.date_range));

    AnalyticsActions.setDate(...Object.values(date_range));
  }
};

export const initBranch = (tracking_disabled, store) => {
  window.branch.init(
    'key_live_jpc4Hi6KhTtrwVHvdvMAQpokDxpB4Poc',
    { tracking_disabled },
    (err, res) => {
      if (err) {
        debug('branchSDK.init: error', err);
        return;
      }
      if (res.data_parsed) {
        if (res.data_parsed.shareablePageState) {
          debug(
            'branchSDK.init: shareableLinkData',
            res.data_parsed.shareablePageState
          );
          store.dispatch(mountFromLinkData(res.data_parsed.shareablePageState));
        }
      }
    }
  );
};
